class ApiAbortController {
  constructor() {
    this.controller = new AbortController();
    this.abortReason = undefined;
  }

  abort(reason) {
    this.controller.abort();
    this.abortReason = reason;
  }
}

export default ApiAbortController;
